import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { default as CommonAcitivities } from '@/src/components/project/Common/Activities/Activities';

import { useActivityLogs } from '../../../../api/getActivityLogs';
import { useEmailThreadEntryViewer } from '../../../../store/emailThreadEntryViewer.store';

const ActivityLogs = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { selectedEmailEntry, isFullScreen } = useEmailThreadEntryViewer();

  const activityLogsQuery = useActivityLogs({
    projectId,
    emailId: selectedEmailEntry.id,
    inboxEntryId: selectedEmailEntry.inboxEntryId,
  });

  if (activityLogsQuery.isLoading) {
    return (
      <SectionLoader
        className={clsx(
          'tw-flex tw-flex-col tw-items-center tw-justify-center',
          'tw-h-full',
          'tw-px-[10px]'
        )}
      />
    );
  }

  const document = {
    id: selectedEmailEntry.id,
    linkId: selectedEmailEntry.inboxEntryId,
    // @TODO: check if props can be sent by BE either from threadDetails api or inboxthread api
    isActive: true,
    isDeleted: false,
    origin: selectedEmailEntry.subject,
    linkSubject: selectedEmailEntry.subject,
  };

  return (
    <div className={clsx('tabContents--activityLogs', 'tw-px-[20px]')}>
      <CommonAcitivities
        activityListHeight={
          isFullScreen ? 'tw-max-h-[calc(100vh-190px)]' : 'tw-max-h-[calc(100vh-340px)]'
        }
        document={document}
        projectId={projectId}
        includeDate={true}
        isLoading={activityLogsQuery.isLoading}
        activityLogs={activityLogsQuery.data?.data || []}
      />
    </div>
  );
};

export default ActivityLogs;
